import { BaseModel } from "@blue-chip/core";

export default class PaymentTerm extends BaseModel {}
